import { DateTime } from "luxon"
import { create } from "zustand"
import { persist } from 'zustand/middleware'
import { SelectedStep } from "../utils/dto/Advisory"

type FormAdvisoryFullStoreState = {
  step?: SelectedStep
  certificationResponse?: any
}

type FormAdvisoryFullStoreActions = {
  setStep: (value: any) => void
  setCertificationResponse: (value: any) => void
  reset: () => void
}

// define the initial state
export const initialFormStoreState: FormAdvisoryFullStoreState = {
  step: undefined,
  certificationResponse: undefined,
}

const useFormAdvisoryFullStore = create<FormAdvisoryFullStoreState & FormAdvisoryFullStoreActions>()(
  persist(
    (set, get) => ({
      ...initialFormStoreState,

      setStep: (value) => set({ step: value }),
      setCertificationResponse : (value) => set({ certificationResponse: value }),
      reset: () => { set(initialFormStoreState) },
    }),
    {
      name: 'form_advisory_full', // name of the item in the storage (must be unique)
    },
  ),
)

export default useFormAdvisoryFullStore;
